<template>
    <div class="bg-deep-blue py-5 px-6 z-10">
        <div class="m-auto max-w-screen-md">
            <div class="flex">
                <router-link
                    :to="{ name: 'create-account', params: { step: getPreviousStep } }"
                    class="button icon-arrow-left mr-5 flex-none text-white !w-24"
                ></router-link>
                <router-link
                    :to="{ name: 'create-account', params: { step: getNextStep } }"
                    class="button icon-arrow-right text-white bg-gradient-to-r from-light-blue to-green flex-1"
                    v-if="!isLastStep"
                >
                    Next Step
                </router-link>
                <div
                    id="submit-application-button"
                    class="button icon-arrow-right text-white bg-gradient-to-r from-light-blue to-green flex-1"
                    v-else-if="user.role !='Admin' && !submission.id"
                    @click="doSubmit"
                >
                    Submit Application
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    name: "StepNavigationComponent",
    data: function () {
        return {};
    },
    components: {},
    computed: {
        ...mapGetters(["user", "stepper", "submission"]),
        getNextStep() {
            let nextStep = parseInt(this.$route.params.step) + 1;
            window.scrollTo(0, 0); // Ensure we are scrolled to the top
            return nextStep > this.stepper.steps.length ? this.stepper.steps.length : nextStep; // Do not allow the user to go beyond the maximum number of specified steps
        },
        getPreviousStep() {
            let previousStep = parseInt(this.$route.params.step) - 1;
            window.scrollTo(0, 0); // Ensure we are scrolled to the top
            return previousStep < 1 ? 1 : previousStep; // Do not allow the user to go below step 1
        },
        isLastStep() {
            return parseInt(this.$route.params.step) == this.stepper.steps.length;
        },
    },
    methods: {
        ...mapActions([
            "doSubmitApplication",
            "showHideGlobalLoader",
            "showHideSubmissionErrorsModal",
            "isSubmissionSuccess",
            "doSetStepperStepStatus"
        ]),
        doSubmit() {
            this.$root.$emit("submittingApplication"); // Emitting a global event used to trigger form validation

            let finalStepStatus = this.stepper.steps[this.stepper.steps.length - 1].status; // Specifically get the final step in the list and check to see if there are errors, if there are then we won't allow the user to proceed to submit the application (Purely for UX).

            if (finalStepStatus == "completed") {
                this.showHideGlobalLoader({ isLoading: true, label: "Submitting application...", overlay: true, description: "Submission can take 1-2 minutes to complete, please do not close this page." });

                setTimeout(() => {
                    let hasInvalidSteps = this.stepper.steps.filter((step) => step.status != "completed");

                    console.log("hasInvalidSteps", hasInvalidSteps);

                    if (hasInvalidSteps.length) {
                        this.showHideGlobalLoader({ isLoading: false, overlay: false });
                        this.showHideSubmissionErrorsModal({ show: true, isServerError: false });
                    } else {
                        console.log("do submit");
                        this.doSubmitApplication(this.user.id).then(
                            (response) => {
                                this.showHideGlobalLoader({ isLoading: false, overlay: false });
                                this.isSubmissionSuccess(true).then(
                                    (response) => {
                                        this.$router.push({name: "submission-success"});
                                    }
                                )
                            },
                            (error) => {
                                this.showHideGlobalLoader({ isLoading: false, overlay: false });
                                if(error.response.data.error != undefined){
                                    switch(error.response.data.error){
                                        case "id_document":
                                            this.showHideSubmissionErrorsModal({ show: true, isServerError: false, isIdDocumentError: error.response.data.reason});
                                            this.$root.$emit("isIdDocumentError");
                                            this.doSetStepperStepStatus({step: 0, status:"error"}); // Manually set first step with an error
                                            break;
                                        case "selfie":
                                            this.showHideSubmissionErrorsModal({ show: true, isServerError: false, isSelfieError: error.response.data.reason});
                                            this.$root.$emit("isSelfieError");
                                            this.doSetStepperStepStatus({step: 2, status:"error"}); // Manually set Selfie Upload step with an error
                                            break;
                                    }
                                }else{
                                    this.showHideSubmissionErrorsModal({ show: true, isServerError: true });
                                }

                            }
                        );
                    }
                }, 1000);
            }
        },
    },
    watch: {
        "$route.params.step"() {
            this.$root.$emit("stepChanged", this.$route.params.step); // Global event emitted to trigger some validation on some form steps
        },
    },
};
</script>
